import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import LoadingStorySection from "./LoadingStorySection";
import LoadingWithAdsSection from "./LoadingWithAdsSection";
import { logger } from "@/lib/logger";

const SmartLoadingSection = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isPaidUser, setIsPaidUser] = useState(false);

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session?.user) {
          // If not authenticated, default to showing ads
          setIsPaidUser(false);
          setIsLoading(false);
          return;
        }

        // Check user's subscription tier
        const { data: subscription, error } = await supabase
          .from('subscriptions')
          .select('tier')
          .eq('user_id', session.user.id)
          .eq('status', 'active')
          .single();
        
        if (error) {
          logger.error('Error fetching subscription:', error);
          // Default to showing ads on error
          setIsPaidUser(false);
        } else {
          // User is paid if they have a 'basic' or 'premium' tier
          setIsPaidUser(subscription?.tier === 'basic' || subscription?.tier === 'premium');
        }
      } catch (error) {
        logger.error('Error checking subscription status:', error);
        // Default to showing ads on error
        setIsPaidUser(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkSubscription();
  }, []);

  // While checking subscription status, show the regular loading screen
  if (isLoading) {
    return <LoadingStorySection />;
  }

  // Based on subscription, show either the standard loading or the ad-supported version
  return isPaidUser ? <LoadingStorySection /> : <LoadingWithAdsSection />;
};

export default SmartLoadingSection;